import { useMemo } from 'react';
import { useCurrentRoute } from 'react-navi';

export const useIsGamePage = () => {
  const {
    url: { pathname },
  } = useCurrentRoute();

  const isGamePage = useMemo(() => pathname.includes('/game/'), [pathname]);

  return { isGamePage };
};
